export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const USER_ROLES = {
  ADMIN: 'admin',
  CLIENT: 'client',
  LEAD_AGENT: 'leadAgent',
};

export const COMMISSION_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
};

export const PROSPECT_SUBMISSION_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
};

export const BUSINESS_MODELS = ['SaaS', 'RevShare', 'Combination', 'Other'];
export const COMMISSION_TYPES = [
  'Event-Based Commission',
  'Recurring Revenue Commission',
  'Event-Based Commission + Recurring Revenue Commission',
];
export const COMMISSION_EVENT_TYPES = [
  'Intro Meeting',
  'Follow-up meeting',
  'Deal Closed',
  'Revenue Milestone',
  '% Rev Share',
  'Other',
];
export const MARKETS_LIST = [
  //new entries
  'Worldwide',
  'North America (US, CA, MX)',
  'Latin America',
  'Europe',
  'Africa',
  'APAC',
  // Priority countries
  'United States',
  'Canada',
  'United Kingdom',
  'Germany',
  'France',
  'Netherlands',
  'Spain',
  'Italy',
  // European countries in alphabetical order
  'Albania',
  'Andorra',
  'Armenia',
  'Austria',
  'Azerbaijan',
  'Belarus',
  'Belgium',
  'Bosnia and Herzegovina',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'Georgia',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Kosovo',
  'Latvia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Moldova',
  'Monaco',
  'Montenegro',
  'North Macedonia',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'San Marino',
  'Serbia',
  'Slovakia',
  'Slovenia',
  'Sweden',
  'Switzerland',
  'Turkey',
  'Ukraine',
  'Vatican City',
  // Regions
  'MENA',
  'CEE',
  'Nordics',
  'Benelux',
  'DACH',
];

export const DOWNLOAD_TABLE_COLUMNS = [
  { key: 'description', label: 'Description', width: '500px' },
  { key: 'url', label: 'URL', width: '540px' },
  // { key: 'logo', label: 'Logo', width: '300px' },
  { key: 'actions', label: '', width: '50px' },
];

export const PRODUCT_TABLE_COLUMNS_SETTING = 'PRODUCT_TABLE_COLUMNS_SETTING';

export const DEFAULT_COMPANY_PRODUCT_TABLE_COLUMNS = [
  { key: 'companyName', label: 'Company Name', width: '150px' },
  { key: 'productName', label: 'Product', width: '200px' },
  { key: 'website', label: 'Website', width: '200px' },
  { key: 'category', label: 'Category', width: '100px' },
  { key: 'businessModel', label: 'Business Model', width: '150px' },
  { key: 'summary', label: 'Summary', width: '200px' },
  { key: 'uspsWhyUs', label: 'Value Proposition', width: '200px' },
  { key: 'idealCustomerProfile', label: 'Ideal Customer Profile', width: '200px' },
  { key: 'targetProfiles', label: 'Key Decision Makers', width: '200px' },
  { key: 'blocklist', label: 'Blocklist', width: '200px' },
  { key: 'markets', label: 'Markets', width: '200px' },
  { key: 'averageMRR', label: 'Average MRR ($)', width: '200px' },
  { key: 'commissionType', label: 'Commission Type', width: '200px' },
  { key: 'commissionFirstTerm', label: 'Commission First Term (%)', width: '200px' },
  { key: 'commissionRenewals', label: 'Commission Renewals (%)', width: '200px' },
  { key: 'duration', label: 'Duration (Months)', width: '200px' },
  { key: 'averageConversionRate', label: 'Average Conversion Rate (%)', width: '200px' },
  { key: 'averageSalesCycle', label: 'Average Sales Cycle (weeks)', width: '200px' },
  { key: 'churn', label: 'Churn (%)', width: '200px' },
  { key: 'oneOffCommissions', label: 'Event-Based Commission', width: '200px' },
  { key: 'conditions', label: 'Conditions', width: '200px' },
  { key: 'buyOutOptions', label: 'Buy Out Options', width: '150px' },
  { key: 'downloads', label: 'Download', width: '150px' },
];

export const DEFAULT_PRODUCT_TABLE_COLUMNS = [
  { key: 'companyLogo', label: 'Logo', width: '100px' },
  { key: 'companyName', label: 'Company Name', width: '150px' },
  { key: 'productName', label: 'Product', width: '200px' },
  { key: 'website', label: 'Website', width: '200px' },
  { key: 'category', label: 'Category', width: '100px' },
  { key: 'businessModel', label: 'Business Model', width: '150px' },
  { key: 'summary', label: 'Summary', width: '200px' },
  { key: 'uspsWhyUs', label: 'Value Proposition', width: '200px' },
  { key: 'idealCustomerProfile', label: 'Ideal Customer Profile', width: '200px' },
  { key: 'targetProfiles', label: 'Key Decision Makers', width: '200px' },
  { key: 'blocklist', label: 'Blocklist', width: '200px' },
  { key: 'markets', label: 'Markets', width: '200px' },
  { key: 'averageMRR', label: 'Average MRR ($)', width: '200px' },
  { key: 'commissionType', label: 'Commission Type', width: '200px' },
  { key: 'commissionFirstTerm', label: 'Commission First Term (%)', width: '200px' },
  { key: 'commissionRenewals', label: 'Commission Renewals (%)', width: '200px' },
  { key: 'duration', label: 'Duration (Months)', width: '200px' },
  // { key: 'averageTotalCommissionValue', label: 'Average Total Commission Value ($)', width: '250px' },
  { key: 'averageConversionRate', label: 'Average Conversion Rate (%)', width: '200px' },
  { key: 'averageSalesCycle', label: 'Average Sales Cycle (weeks)', width: '200px' },
  { key: 'churn', label: 'Churn (%)', width: '200px' },
  { key: 'oneOffCommissions', label: 'Event-Based Commission', width: '200px' },
  { key: 'conditions', label: 'Conditions', width: '200px' },
  { key: 'buyOutOptions', label: 'Buy Out Options', width: '150px' },
  { key: 'downloads', label: 'Download', width: '150px' },
];

export const COLUMN_LABEL_MAP = {
  companyLogo: 'Logo',
  companyName: 'Company',
  product: 'Product',
  website: 'Website',
  category: 'Category',
  businessModel: 'Model',
  summary: 'Summary',
  usps: 'Value Proposition',
  idealCustomerProfile: 'Ideal Customer Profile',
  targetProfiles: 'Key Decision Makers',
  blocklist: 'Blocklist',
  markets: 'Markets',
  averageMRR: 'Avg. MRR ($)',
  commissionType: 'Type',
  commissionFirstTerm: 'First Term (%)',
  commissionRenewals: 'Renewals (%)',
  duration: 'Duration (Months)',
  // averageTotalCommissionValue: 'Avg. Total Comm. ($)',
  averageConversionRate: 'Conv. Rate (%)',
  averageSalesCycle: 'Avg. Sales Cycle (wks)',
  churn: 'Churn (%)',
  oneOffCommissions: 'Event-Based Commission',
  conditions: 'Conditions',
  buyOutOptions: 'Buyout Options',
  downloads: 'Downloads',
};

export const DEFAULT_USERS_TABLE_COLUMNS = [
  { key: 'firstName', label: 'First Name', width: '100px' },
  { key: 'lastName', label: 'Second Name', width: '150px' },
  { key: 'email', label: 'Email', width: '200px' },
  { key: 'isApproved', label: 'Status', width: '100px' },
  { key: 'approvedAt', label: 'Approval Timestamp', width: '250px' },
];
